import {TFunction} from 'i18next';
import {DosageIntervalType} from '../types/prescription';
import {DosageFrequencyOption} from '../validators/newPrescription';

type DosageValues = {
    treatmentDuration?: number | null;
    dosageInterval?: number | null;
    dosageIntervalType?: DosageIntervalType | null;
    dosageAmount?: number | null;
    dosageUnit?: string | null;
    usageRecommendation?: string | null;
};

export const getDosageIntervalData = (
    frequencyOption: DosageFrequencyOption | '',
    dosageIntervalHours: number | null,
) => {
    if (!frequencyOption) {
        return {
            dosageInterval: null,
            dosageIntervalType: null,
        };
    }

    if (frequencyOption === 'xH') {
        return {
            dosageInterval: dosageIntervalHours,
            dosageIntervalType: 'xH' as DosageIntervalType,
        };
    }

    return {
        dosageInterval: Number(frequencyOption[0]),
        dosageIntervalType: 'xD' as DosageIntervalType,
    };
};

export const mapDosageToFrequencyOption = (
    dosageIntervalType: DosageIntervalType | null | undefined,
    dosageInterval: number | null | undefined,
) => {
    if (!dosageIntervalType || !dosageInterval) {
        return {
            dosageFrequencyOption: '' as DosageFrequencyOption | '',
            dosageIntervalHours: '' as number | string,
        };
    }

    if (dosageIntervalType === 'xH') {
        return {
            dosageFrequencyOption: 'xH' as DosageFrequencyOption,
            dosageIntervalHours: dosageInterval,
        };
    }

    if (dosageInterval >= 1 && dosageInterval <= 4) {
        return {
            dosageFrequencyOption: `${dosageInterval}x1` as DosageFrequencyOption,
            dosageIntervalHours: '' as number | string,
        };
    }

    return {
        dosageFrequencyOption: '' as DosageFrequencyOption | '',
        dosageIntervalHours: '' as number | string,
    };
};

export const getDosageDisplayValue = (
    dosage: DosageValues,
    t: TFunction,
) => {
    const displayValues: string[] = [];

    if (dosage.treatmentDuration != null) {
        displayValues.push(`${t('treatmentDuration')}: ${dosage.treatmentDuration}`);
    }

    if (dosage.dosageInterval != null && dosage.dosageIntervalType) {
        if (dosage.dosageIntervalType === 'xD') {
            displayValues.push(`${dosage.dosageInterval}x1`);
        }
        if (dosage.dosageIntervalType === 'xH') {
            displayValues.push(t('everyXHours', {hours: dosage.dosageInterval}));
        }
    }

    if (dosage.dosageAmount != null || dosage.dosageUnit) {
        displayValues.push(
            `${dosage.dosageAmount ?? ''} ${dosage.dosageUnit ?? ''}`.trim(),
        );
    }

    if (dosage.usageRecommendation?.trim()) {
        displayValues.push(dosage.usageRecommendation.trim());
    }

    return displayValues.join(', ') || '-';
};